import request from '@/utils/request'

// 查询认定优质基地管理列表
export function listRdyzjd(query) {
  return request({
    url: '/web/zlts/rdyzjd/list',
    method: 'get',
    params: query
  })
}

// 查询认定优质基地管理详细
export function getRdyzjd(recid) {
  return request({
    url: '/web/zlts/rdyzjd/' + recid,
    method: 'get'
  })
}

// 查询认定优质基地管理列表(质量品牌服务模块)
export function rdyzjdList(query) {
  return request({
    url: '/web/zlts/rdyzjd/rdyzjdList',
    method: 'get',
    params: query
  })
}